<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import GridFotos from './components/GridFotos.vue'
import axios from '@/utils/api'

export default {
  components: {
    Label,
    AppDisplay,
    GridFotos
  },
  props: {
    cadastro: {
      type: Object
    },
    protocolo: {
      type: String
    },
    dados: {
      type: Object
    }
  },
  data () {
    return {
      fotos: {
        PRPD: { loading: false, srcList: [] },
        SPDG: { loading: false, srcList: [] },
        SPDH: { loading: false, srcList: [] },
        ILPF: { loading: false, srcList: [] },
        SAF: { loading: false, srcList: [] },
        FP: { loading: false, srcList: [] },
        MRPA: { loading: false, srcList: [] },
        TI: { loading: false, srcList: [] },
        OUTROS: { loading: false, srcList: [] }
      }
    }
  },
  methods: {
    async handleDownloadFotos (name) {
      if (!name || !name.length) return
      const lastInteract = name[name.length - 1]
      if (!this.fotos[lastInteract]?.srcList.length) {
        this.fotos[lastInteract].loading = true
        this.fotos[lastInteract].srcList = await this.downloadFotos(lastInteract)
        this.fotos[lastInteract].loading = false
      }
    },
    getTipoFoto (foto) {
      if (foto === 'OUTROS') {
        return 'OUTROS'
      }
      return `PRATICA_${foto}`
    },
    async downloadFotos (pratica) {
      const tipo = this.getTipoFoto(pratica)
      const fotos = await axios({
        method: 'POST',
        url: 'foto/getFotosView/byProtocolo',
        data: { protocolo: this.protocolo, tipo },
        loader: false
      })
      return fotos
    }
  },
  computed: {
    praticas () {
      return this.cadastro.praticas
    },
    hasAnyPratica () {
      return this.praticas.praticaSustentavelPRPD ||
      (this.praticas.praticaSustentavelSPDG && this.praticas.praticaSustentavelSPDG.length) ||
      (this.praticas.praticaSustentavelSPDH && this.praticas.praticaSustentavelSPDH.length) ||
      this.praticas.praticaSustentavelILPF ||
      this.praticas.praticaSustentavelSAF ||
      this.praticas.praticaSustentavelFP ||
      this.praticas.praticaSustentavelMRPA ||
      this.praticas.praticaSustentavelTI
    }
  }
}

</script>

<template>
  <div v-loading="dados.loading" :style="dados.loading ? 'min-height: 100px;' : ''">
    <div v-if="hasAnyPratica || dados.hasOutros">
      <el-collapse @change="handleDownloadFotos">
        <el-collapse-item v-if="praticas.praticaSustentavelPRPD" title="Práticas para Recuperação de Pastagens Degradadas (PRPD)" name="PRPD">
          <GridFotos :fotos="fotos['PRPD']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSPDG && praticas.praticaSustentavelSPDG.length" title="Sistema de Plantio Direto de Grãos (SPDG)" name="SPDG">
          <GridFotos :fotos="fotos['SPDG']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSPDH && praticas.praticaSustentavelSPDH.length" title="Sistema de Plantio Direto de Hortaliças (SPDH)" name="SPDH">
          <GridFotos :fotos="fotos['SPDH']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelILPF" title="Integração Lavoura-Pecuária-Floresta (ILPF)" name="ILPF">
          <GridFotos :fotos="fotos['ILPF']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelSAF" title="Sistemas Agroflorestais (SAF)" name="SAF">
          <GridFotos :fotos="fotos['SAF']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelFP" title="Florestas Plantadas (FP)" name="FP">
          <GridFotos :fotos="fotos['FP']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelMRPA" title="Manejo de Resíduos da Produção Animal (MRPA)" name="MRPA">
          <GridFotos :fotos="fotos['MRPA']" />
        </el-collapse-item>
        <el-collapse-item v-if="praticas.praticaSustentavelTI" title="Terminação intensiva (TI)" name="TI">
          <GridFotos :fotos="fotos['TI']" />
        </el-collapse-item>
        <el-collapse-item v-if="dados.hasOutros" title="Outros" name="OUTROS">
          <GridFotos :fotos="fotos['OUTROS']" />
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else>
      <span>Nenhuma foto foi anexada ao cadastro.</span>
    </div>
  </div>

</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Galeria/Galeria.vue